import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";

// fetch all security records
export const fetchSecurityRecords = createAsyncThunk(
    "securityRulesRecords/fetchAll",
    async () => {
      const { data } = await api.get(API_ENDPOINTS.security.securityRulesRecords.getAll);
      console.log(data)
      return data;
    }
  );

  
// fetch one record-rule by ID
export const fetchSecurityRecordById = createAsyncThunk(
  "securityRulesRecords/fetchById",
  async (id) => {
    const { data } = await api.get(
      API_ENDPOINTS.security.securityRulesRecords.getById + id
    );
    return data;
  }
);

// create a new record-rule
export const createSecurityRecord = createAsyncThunk(
  "securityRulesRecords/create",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.securityRulesRecords.create,
      payload
    );
    return data;
  }
);

// update an existing record-rule
export const updateSecurityRecord = createAsyncThunk(
  "securityRulesRecords/update",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.securityRulesRecords.update,
      payload
    );
    return data;
  }
);

// delete a record-rule
export const deleteSecurityRecord = createAsyncThunk(
  "securityRulesRecords/delete",
  async (id) => {
    await api.delete(
      API_ENDPOINTS.security.securityRulesRecords.delete + id
    );
    return id;
  }
);
